import {CLEAR_USER, EDIT_USER, EDIT_USER_FAIL, FETCH_USER, POST_USER, POST_USER_FAIL} from "../userTypes";

const initialState = {
    id: 0,
    firstName: "",
    lastName: "",
    tags:[],
    roles: [],
    phone: "",
    photo: "",
    email: "",
    projects: [],
    status: 0
}
const oneUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USER:
            return {
                ...state,
                id: action.payload.id,
                firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                tags:action.payload.tags,
                roles: action.payload.roles,
                phone: action.payload.phone,
                photo: action.payload.photo,
                email: action.payload.email,
                projects: action.payload.projects,
                status: 0,

            }
        case EDIT_USER:
            return {
                ...state,
                id: action.payload.id,
                firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                tags:action.payload.tags,
                roles: action.payload.roles,
                phone: action.payload.phone,
                photo: action.payload.photo,
                email: action.payload.email,
                projects: action.payload.projects,
                status: action.payload.status,
            }
        case EDIT_USER_FAIL:
            return {
                ...state,
                status: action.payload.status
            }
        case POST_USER :
            return {
                ...state,
                status: action.payload.status
            }
        case POST_USER_FAIL :
            return {
                ...state,
                status: action.payload.status
            }
        case CLEAR_USER:
            return {
                id: 0,
                firstName: "",
                lastName: "",
                roles: [],
                phone: "",
                photo: "",
                email: "",
                projects: [],
                status:0
            }
        default:
            return {
                ...state
            }
    }
}
export default oneUserReducer;